define([
	"dijit/form/Button",
	"./_Plugin",
	"./PluginFactory",
	"./util"
], function(Button,_Plugin,PluginFactory,util) {

	return PluginFactory.declare([Button, _Plugin], {
		materialIcon: "close",
		pluginName: "delete",
		title: "Delete",

		/**
		 * @override
		 * Only enable if at least one shape is selected, parent test passed, and at least one shape is unlocked.
		 * Do not enable if attribute placeholder sub-object is selected.
		 * Enable if custom curve has points or is default mode.
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			const { editor } = this;
			if (!!shapes && util.unlockedShapedCount(shapes) >= 1) {
				if (shapes.length === 1 && shapes[0].attributeKey) {
					return true;
				}

				return (
					!editor.isCropPictureMode() &&
					(editor.isEditPenMode() ||
					editor.isEditCustomCurveAndHasPoints() ||
					editor.isDefaultCanvasMode())
				);
			}
			return false;
		},

		/**
		 * Handle clicking the delete button
		 * @param {PointerEvent} e 
		 */
		onClick: function(e) {
			const { editor } = this;
			// summary: delete selected shapes
			if (editor.isEditCustomCurve() || editor.isEditPenMode()) {
				editor.canvasApp.pageApi().deleteCurvePoint();
			} else {
				editor.deleteShapes();
			}
		}
	});
});
